import React from 'react';
import { Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import AirlineSeatFlatIcon from '@mui/icons-material/AirlineSeatFlat';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import ScaleIcon from '@mui/icons-material/Scale';

const ProgressWheelCard = ({ title, value, target, unit, color, icon }) => {
  const progress = (value / target) * 100;

  // Icon selection based on the 'icon' prop
  const renderIcon = () => {
    switch (icon) {
      case 'calories':
        return <FastfoodIcon sx={{ fontSize: 40, color: '#fff' }} />;
      case 'water':
        return <LocalDrinkIcon sx={{ fontSize: 40, color: '#fff' }} />;
      case 'sleep':
        return <AirlineSeatFlatIcon sx={{ fontSize: 40, color: '#fff' }} />;
      case 'weight':
        return <ScaleIcon sx={{ fontSize: 40, color: '#fff' }} />;
      case 'workout':
        return <FitnessCenterIcon sx={{ fontSize: 40, color: '#fff' }} />;
      default:
        return <DirectionsRunIcon sx={{ fontSize: 40, color: '#fff' }} />;
    }
  };

  return (
    <Card
      sx={{
        minWidth: 275,
        marginBottom: 2,
        textAlign: 'center',
        borderRadius: 2,
        background: `linear-gradient(45deg, ${color[0]} 30%, ${color[1]} 90%)`,
        color: '#fff',
        position: 'relative',
        padding: 2,
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="body2">{`${title}: ${value} ${unit}`}</Typography>
          <Typography variant="body2">{`Target: ${target} ${unit}`}</Typography>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
          {renderIcon()}
        </Box>
        <Box position="relative" display="inline-flex">
          <CircularProgress variant="determinate" value={progress} size={80} thickness={5} sx={{ color: '#fff' }} />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="caption" component="div" color="textSecondary">
              {`${Math.round(progress)}%`}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProgressWheelCard;
